import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import { type GetTemplatesResponse } from '#shared/api/schema';

export const TemplateTag = 'Template' as const;

export const api = createApi({
    name: 'entities/constructor/api/templates/api',
    tagTypes: [TemplateTag],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getAll: builder.query<GetTemplatesResponse, {}>({
                query: () => {
                    return {
                        url: `/templates`,
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const useConstructorDesignTemplatesQuery = api.useGetAllQuery;
